import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import styled from 'styled-components';
import { safelyDecodeBase64Url } from '@dev/ee-tools';

import { StackedBarChart, Tip, Typography } from '@dev/ee-components';
import { getCampainCreatorStore, LoadCampaignSimpleStatsStart } from '@/store/campaignCreator/actions';
import { useCampaignScreensPathsChecker } from '@/components/CampaignCreator/hooks/useCampaignScreensPathsChecker';
import { useGetChartData } from '@/components/CampaignCreator/hooks/useGetChartData';
import { useGetSummaryData } from '@/components/CampaignCreator/hooks/useGetSummaryData';
import { CampaignSummary } from './components/CampaignSummary';

const ChartWrapper = styled.div`
    width: 100%;
    padding-top: 30px;
    display: inline-flex;
    align-items: center;

    .cellWrapperStackerBarChart {
        display: flex;
        justify-content: center;

        &:last-of-type {
            justify-content: start;
        }
    }
`;

const TipWrapper = styled.div`
    margin-left: 24px;
`;

export const AbReport = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { isDetailsScreen } = useCampaignScreensPathsChecker();
    const { campaign, isLoading, campaignSimpleStatsLoading } = useSelector(getCampainCreatorStore);
    const { name } = useParams<{ name: string; type: string }>();
    const chartData = useGetChartData();
    const summaryData = useGetSummaryData();
    const recipientsCount = campaign?.RecipientsCount;
    const isCampaignSummaryLoading = isDetailsScreen ? campaignSimpleStatsLoading : isLoading;

    useEffect(() => {
        if (isDetailsScreen && !isLoading) {
            const from = campaign?.TriggerOptions?.DateToSendOn;
            dispatch(LoadCampaignSimpleStatsStart(safelyDecodeBase64Url(name), from));
        }
    }, []);

    return (
        <>
            <ChartWrapper>
                <StackedBarChart
                    data={chartData}
                    totalCount={recipientsCount}
                    cellPadding={'8px 17px'}
                    hideLegend={true}
                />
                {!isDetailsScreen && (
                    <TipWrapper>
                        <Tip id={`send-to-summary-tooltip`}>
                            <Typography variant="body1" bodyVariant="onPaper">
                                {t('werecommendsettingup')}
                            </Typography>
                        </Tip>
                    </TipWrapper>
                )}
            </ChartWrapper>
            <CampaignSummary data={summaryData} isLoading={isCampaignSummaryLoading} />
        </>
    );
};
